import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录', index: 0 },
    component: () => import('@/page/login.vue')
  },
  {
    path: '/projectList',
    name: 'ProjectList',
    meta: { title: '项目列表', index: 1, requiresAuth: true },
    component: () => import('@/page/projectList.vue')
  },
  {
    path: '/createProject',
    name: 'CreateProject',
    meta: { title: '创建项目', index: 2, requiresAuth: true },
    component: () => import('@/page/createProject.vue')
  },
  {
    path: '/createProjectForm',
    name: 'CreateProjectForm',
    meta: { title: '填写项目表单', index: 3, requiresAuth: true },
    component: () => import('@/page/createProjectForm.vue')
  },
  {
    path: '/editProjectForm/:projectId',
    name: 'EditProjectForm',
    meta: { title: '编辑项目表单', index: 3, requiresAuth: true },
    component: () => import('@/page/editProjectForm.vue')
  },
  {
    path: '/workOrderList/:id',
    name: 'WorkOrderList',
    meta: { title: '工单列表',  index: 2, requiresAuth: true },
    component: () => import('@/page/workOrderList.vue')
  },
  {
    path: '/createWorkOrder',
    name: 'CreateWorkOrder',
    meta: { title: '创建工单', index: 3, requiresAuth: true },
    component: () => import('@/page/createWorkOrder.vue')
  },
  {
    path: '/logList/:id',
    name: 'LogList',
    meta: { title: '日志列表',index: 3, requiresAuth: true },
    component: () => import('@/page/logList.vue')
  },
  {
    path: '/logDetail/:id',
    name: 'LogDetail',
    meta: { title: '日志详情', keepAlive: false, index: 4, requiresAuth: true },
    component: () => import('@/page/logDetail.vue')
  },
  {
    path: '/invoiceDetail/:id',
    name: 'InvoiceDetail',
    meta: { title: '发票详情', index: 4, requiresAuth: true },
    component: () => import('@/page/invoiceDetail.vue')
  },
  {
    path: '/superLog',
    name: 'SuperLog',
    meta: { title: '超级日志', keepAlive: true, index: 1, requiresAuth: true },
    component: () => import('@/page/superLog.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    meta: { title: '页面未找到' },
    component: () => import('@/page/notFound.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

let isRedirectingToLogin = false;

router.beforeEach((to, from, next) => {
  const routeName = to.name;
  const customTitle = store.getters.getPageTitle(routeName);
  const defaultTitle = to.meta.title || 'JLDA';
  const pageTitle = customTitle || defaultTitle;
  document.title = pageTitle;

  if (to.meta.requiresAuth) {
    if (!store.getters.isLogin) {
      if (isRedirectingToLogin) {
        return next(false);
      }
      isRedirectingToLogin = true;
      return next({
        name: 'Login',
        query: { redirect: to.fullPath }
      });
    }
  }

  if (to.name === 'Login' && store.getters.isLogin) {
    return next({ name: 'ProjectList' });
  }

  next();
});

router.setRedirectingToLogin = (value) => {
  isRedirectingToLogin = value;
};

export default router;
